<template>
  <Layout kind="narrow">
    <div class="tabs is-fullwidth is-boxed">
      <ul>
        <router-link
          tag="li"
          :to="{ name: 'Search' }"
          icon="fa-align-left"
          active-class="is-active"
          exact
        ></router-link>
        <!-- <router-link
          tag="li"
          :to="{ name: 'Tags' }"
          icon="fa-tags"
          active-class="is-active"
          exact
          ><a>{{$t("Tags")}} <b-icon icon="tags" size="is-small"> </b-icon></a></router-link
        > -->
        <!-- <router-link
          tag="li"
          :to="{ name: 'Metadata' }"
          icon="fa-database"
          active-class="is-active"
          exact
          ><a>Metadata <b-icon icon="database" size="is-small"> </b-icon></a
        ></router-link> -->
      </ul>
    </div>
    <!-- <template #sidebar>
      <SearchSidebar> -->
    <!-- <Panel
          :label="$t(facetLable(option))"
          v-for="option in facets.meta"
          :key="option.facet_field"
        >
          <b-button
            icon-left="filter"
            expanded
            @click="openModal(option, facetLable(option))"
            >{{ facetLableSelect(option) }}</b-button
          >
        </Panel>
        <Panel
          v-for="(rangeEntry, index) in rangeFields"
          :label="$t(rangeEntry.field)"
          :key="index"
        >
          <RangeFilter
            :min="rangeEntry.from"
            :max="rangeEntry.to"
            :label="$t(rangeEntry.field)"
            :name="rangeEntry.field"
          />
        </Panel> -->
    <!-- <SearchFacets /> -->
    <!-- </SearchSidebar>
    </template> -->
    <div v-if="query.term" class="columns box" style="margin-bottom : 2rem;">
      <div
        class="column"
        :label="$t(facetLable(option))"
        v-for="option in facets.meta"
        :key="option.facet_field"
        :aria-label="$t(facetLable(option))"
      >
        <b-button
          icon-left="filter"
          expanded
          @click="openModal(option, facetLable(option))"
          >{{ facetLableSelect(option) }}</b-button
        >
      </div>
      <div
        class="column"
        v-for="(rangeEntry, index) in rangeFields"
        :label="$t(rangeEntry.field)"
        :aria-label="$t(rangeEntry.field)"
        :key="index"
      >
        <RangeFilter
          :min="rangeEntry.from"
          :max="rangeEntry.to"
          :label="$t(rangeEntry.field)"
          :name="rangeEntry.field"
        />
      </div>
    </div>
    <SearchForm style="margin-bottom: 0.75rem"></SearchForm>

    <SearchResult @setFacets="setFacets"></SearchResult>
  </Layout>
</template>

<script>
import SearchLayout from "@/components/SearchLayout.vue";
import SearchSidebar from "@/components/SearchSidebar.vue";
import SearchFacets from "@/components/SearchFacets.vue";
import SearchForm from "@/components/SearchForm.vue";
import SearchResult from "@/components/SearchResult.vue";
import RangeFilter from "@/components/Filter/RangeFilter.vue";
import Panel from "@/components/Panel.vue";
import StringFilterModal from "@/components/Filter/StringFilterModal.vue";
import Layout from "@/components/Layout.vue";

import { createMapper } from "@/utils/mapping.js";

import config from "@/config.json";

const mapper = createMapper("browser");

export default {
  components: {
    SearchLayout,
    SearchSidebar,
    SearchFacets,
    SearchForm,
    SearchResult,
    RangeFilter,
    Panel,
    Layout,
  },
  watch: {
    activeTab() {
      this.$router.push({ query: {} });
    },
  },
  data() {
    return {
      activeTab: 0,
      facets: [],
    };
  },
  methods: {
    setFacets(value) {
      this.facets = value;
    },
    facetLableSelect(option) {
      let query = { ...this.$route.query };
      var label = query[Object.keys(option)[0]];
      if (label) {
        if (Array.isArray(label)) {
          return this.truncate(label.join(), 30);
        }
        return this.truncate(label, 30);
      }
      return this.$t(Object.keys(option)[0]);
    },
    truncate(str, n) {
      return str.length > n ? str.substr(0, n - 1) + "..." : str;
    },
    facetLable(option) {
      return Object.keys(option)[0];
    },
    openModal(option, label) {
      var items = option[Object.keys(option)[0]];
      items.sort((a, b) => a.value.localeCompare(b.value));
      var modal = this.$buefy.modal.open({
        parent: this,

        component: StringFilterModal,
        events: {
          closeModal: (value) => {
            option.label = this.truncate(value.join(), 50);
            modal.close();
          },
        },
        trapFocus: true,
        destroyOnHide: false,
        props: {
          items: items,
          name: label,
          label: label,
        },
      });
    },
  },
  computed: {
    layout() {
      const { term } = this.query;
      return !term ? "narrow" : "sidebar";
    },
    query() {
      return mapper.fromURL(this.$route.query);
    },
    rangeFields() {
      return config.range;
    },
  },
};
</script>
